import { render, staticRenderFns } from "./toptire-news.vue?vue&type=template&id=18a7861b&"
import script from "./toptire-news.vue?vue&type=script&lang=js&"
export * from "./toptire-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports